module.exports = __webpack_public_path__ + "static/media/027-american-samoa.35c5e27e.svg";